import { ProgressRadial, Text } from "@itwin/itwinui-react";
import styles from "./LoadingSpinner.module.css";

interface FormSpinnerProps {
  message?: string;
  size?: '' | 'x-small' | 'small' | 'large';
  centered?: boolean;
  hPos?: "left" | "center" | "right"
}

export const LoadingSpinner = ({ message, size, centered, hPos }: FormSpinnerProps) => {
  let positionClass = styles.spinnerCenter;

  if (hPos === "left")
    positionClass = styles.spinnerLeft;
  if (hPos === "right")
    positionClass = styles.spinnerRight;

  return (
    <div className={[centered ? styles.spinnerContainer : "", positionClass].join(" ")} data-testid="atp-loading-spinner">
      <div className={styles.inner}>
        <ProgressRadial indeterminate size={size} />
        {message && <Text isMuted>{message}</Text>}
      </div>
    </div>
  )
};